import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const LinkIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 19 18.998"
    >
      <g transform="translate(1 1)">
        <path
          d="M783.836,83.819l-.408.408a6.051,6.051,0,0,1-8.558-8.558l.408-.408"
          transform="translate(-773.097 -69.001)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M779.358,71.181l.408-.408a6.051,6.051,0,0,1,8.558,8.558l-.408.408"
          transform="translate(-773.097 -69.001)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="3.841"
          y2="3.841"
          transform="translate(6.58 6.579)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
